import { render, staticRenderFns } from "./o-layout-x2-row.vue?vue&type=template&id=2b53457d&scoped=true"
import script from "./o-layout-x2-row.vue?vue&type=script&lang=js"
export * from "./o-layout-x2-row.vue?vue&type=script&lang=js"
import style0 from "./o-layout-x2-row.vue?vue&type=style&index=0&id=2b53457d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53457d",
  null
  
)

export default component.exports